<template>
  <div id="sidebar-menu">
    <!-- {{layoutobject}}	
          fdsfdsf{{[layoutobject.split(' ').includes('horizontal-wrapper')]}} -->
    <ul
      class="sidebar-links custom-scrollbar"
      id="myDIV"
      :style="[
        layoutobject.split(' ').includes('horizontal-wrapper')
          ? layout.settings.layout_type == 'rtl'
            ? { '  -right': margin + 'px' }
            : { 'margin-left': margin + 'px' }
          : { margin: '0px' },
      ]"
    >
      <li class="back-btn">
        <router-link to="/">
          <img class="img-fluid" src="../../assets/images/logo/logo.svg" alt=""
        /></router-link>
        <div class="mobile-back text-end">
          <span>Back</span
          ><i class="fa fa-angle-right ps-2" aria-hidden="true"></i>
        </div>
      </li>
      <!-- <li
        :class="isPath === '/cross-directorate-summary' ? 'active' : ''"
        class="sidebar-list"
      >
        <label class="badge badge-light-primary"></label
        ><router-link
          class="sidebar-link sidebar-title"
          to="/cross-directorate-summary"
        >
          <svg
            :class="
              isPath === '/cross-directorate-summary' ? 'active-stroke' : ''
            "
            class="stroke-icon"
          >
            <use href="@/assets/svg/icon-sprite.svg#transmission"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#transmission"></use>
          </svg>
          <span
            :class="
              isPath === '/cross-directorate-summary' ? 'active-text' : ''
            "
            class="lan-3"
            >Cross Directorate Summary</span
          ></router-link
        >
      </li> -->
      <!-- <li class="sidebar-main-title">
        <div>
          <h6 class="lan-1">General</h6>
        </div>
      </li> -->
      <!-- <li :class="isPath === '/' ? 'active' : ''" class="sidebar-list">
        <label class="badge badge-light-primary"></label
        ><router-link class="sidebar-link sidebar-title" to="/">
          <svg
            :class="isPath === '/' ? 'active-stroke' : ''"
            class="stroke-icon"
          >
            <use href="@/assets/svg/icon-sprite.svg#stroke-menu"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#fill-menu"></use>
          </svg>
          <span :class="isPath === '/' ? 'active-text' : ''" class="lan-3"
            >PLN Management contract
          </span></router-link
        >
      </li>
      <li :class="isPath === '/finance' ? 'active' : ''" class="sidebar-list">
        <label class="badge badge-light-primary"></label
        ><router-link class="sidebar-link sidebar-title" to="/finance">
          <svg
            :class="isPath === '/finance' ? 'active-stroke' : ''"
            class="stroke-icon"
          >
            <use href="@/assets/svg/icon-sprite.svg#stroke-coin"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#fill-coin"></use>
          </svg>
          <span
            :class="isPath === '/finance' ? 'active-text' : ''"
            class="lan-3"
            >Finance
          </span></router-link
        >
      </li>
      <li
        :class="isPath === '/legal-human-capital' ? 'active' : ''"
        class="sidebar-list"
      >
        <label class="badge badge-light-primary"></label
        ><router-link
          class="sidebar-link sidebar-title"
          to="/legal-human-capital"
        >
          <svg
            :class="isPath === '/legal-human-capital' ? 'active-stroke' : ''"
            class="stroke-icon"
          >
            <use href="@/assets/svg/icon-sprite.svg#human-capital"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#fill-coin"></use>
          </svg>
          <span
            :class="isPath === '/legal-human-capital' ? 'active-text' : ''"
            class="lan-3"
            >Legal & Human Capital</span
          ></router-link
        >
      </li>
      <li
        :class="isPath === '/generation' ? 'active' : ''"
        class="sidebar-list"
      >
        <label class="badge badge-light-primary"></label
        ><router-link class="sidebar-link sidebar-title" to="/generation">
          <svg
            :class="isPath === '/generation' ? 'active-stroke' : ''"
            class="stroke-icon"
          >
            <use href="@/assets/svg/icon-sprite.svg#stroke-generation"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#fill-icons"></use>
          </svg>
          <span
            :class="isPath === '/generation' ? 'active-text' : ''"
            class="lan-3"
            >Generation
          </span></router-link
        >
      </li>
      <li
        :class="isPath === '/distribution' ? 'active' : ''"
        class="sidebar-list"
      >
        <label class="badge badge-light-primary"></label
        ><router-link class="sidebar-link sidebar-title" to="/distribution">
          <svg
            :class="isPath === '/distribution' ? 'active-stroke' : ''"
            class="stroke-icon"
          >
            <use href="@/assets/svg/icon-sprite.svg#stroke-distribution"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#fill-icons"></use>
          </svg>
          <span
            :class="isPath === '/distribution' ? 'active-text' : ''"
            class="lan-3"
            >Distribution
          </span></router-link
        >
      </li>
      <li
        :class="isPath === '/data-moonshot' ? 'active' : ''"
        class="sidebar-list"
      >
        <label class="badge badge-light-primary"></label>
        <router-link class="sidebar-link sidebar-title" to="/data-moonshot">
          <svg
            :class="isPath === '/data-moonshot' ? 'active-stroke' : ''"
            class="stroke-icon"
          >
            <use href="@/assets/svg/icon-sprite.svg#moonshot"></use>
          </svg>
          <svg
            :class="isPath === '/data-moonshot' ? 'active-stroke' : ''"
            class="fill-icon"
          >
            <use href="@/assets/svg/icon-sprite.svg#moonshot"></use>
          </svg>
          <span
            :class="isPath === '/data-moonshot' ? 'active-text' : ''"
            class="lan-3"
            >Moonshot
          </span></router-link
        >
      </li>
      <li :class="isPath === '/esg' ? 'active' : ''" class="sidebar-list">
        <label class="badge badge-light-primary"></label>
        <router-link class="sidebar-link sidebar-title" to="/esg">
          <svg
            :class="isPath === '/esg' ? 'active-stroke' : ''"
            class="stroke-icon"
          >
            <use href="@/assets/svg/icon-sprite.svg#esg"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#esg"></use>
          </svg>
          <span
            :class="isPath === '/finance' ? 'active-text' : ''"
            class="lan-3"
            >ESG
          </span></router-link
        >
      </li> -->
      <li
        v-for="(menuItem, index) in filteredItems"
        :key="index"
        class="sidebar-list"
        style="margin-left: 10px; padding-right: 35px"
      >
        <label
          :class="'badge badge-' + menuItem.badgeType"
          v-if="menuItem.badgeType"
          >{{ menuItem.badgeValue }}</label
        >
        <a
          :href="menuItem.path"
          class="sidebar-link sidebar-title"
          :class="{ active: menuItem.active }"
          v-if="menuItem.type == 'sub'"
          @click="setNavActive(menuItem, index)"
        >
          <svg class="stroke-icon">
            <use
              :xlink:href="
                getIconUrl(menuItem.icon)
              "
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              :xlink:href="
                getIconUrl(menuItem.iconf)
              "
            ></use>
          </svg>
          <span class="lan-3">
            {{ menuItem.title }}
          </span>
          <div class="according-menu" v-if="menuItem.children">
            <i class="fa fa-angle-right pull-right"></i>
          </div>
        </a>
        <router-link
          :to="menuItem.path"
          class="sidebar-link sidebar-title"
          v-if="menuItem.type == 'link'"
          :class="{ active: menuItem.active }"
          v-on:click="hidesecondmenu()"
          @click="setNavActive(menuItem, index)"
        >
          <svg class="stroke-icon">
            <use
              :xlink:href="
                getIconUrl(menuItem.icon)
              "
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              :xlink:href="
                getIconUrl(menuItem.iconf)
              "
            ></use>
          </svg>
          <span>
            {{ menuItem.title }}
          </span>
          <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
        </router-link>

        <a
          :href="menuItem.path"
          class="sidebar-link sidebar-title"
          v-if="menuItem.type == 'extLink'"
          @click="setNavActive(menuItem, index)"
        >
          <svg class="stroke-icon">
            <use
              :xlink:href="
                getIconUrl(menuItem.icon)
              "
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              :xlink:href="
                getIconUrl(menuItem.iconf)
              "
            ></use>
          </svg>
          <span>
            {{ menuItem.title }}
          </span>
          <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
        </a>

        <a
          :href="menuItem.path"
          target="_blank"
          class="sidebar-link sidebar-title"
          v-if="menuItem.type == 'extTabLink'"
          @click="setNavActive(menuItem, index)"
        >
          <svg class="stroke-icon">
            <use
              :xlink:href="
              getIconUrl(menuItem.icon)
              "
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              :xlink:href="
              getIconUrl(menuItem.iconf)
              "
            ></use>
          </svg>
          <span style="color: white">
            {{ menuItem.title }}
          </span>
          <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
        </a>

        <ul
          class="sidebar-submenu"
          v-if="menuItem.children"
          :class="{ 'menu-open': menuItem.active }"
          :style="{ display: menuItem.active ? '' : 'none' }"
        >
          <li v-for="(childrenItem, index) in menuItem.children" :key="index">
            <a
              style="color: white"
              class="lan-4"
              :class="{ active: childrenItem.active }"
              href="javascript:void(0)"
              v-if="childrenItem.type == 'sub'"
              @click="setNavActive(childrenItem, index)"
            >
              {{ childrenItem.title }}
              <label
                :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
                v-if="childrenItem.badgeType"
                >{{ childrenItem.badgeValue }}</label
              >
              <i
                class="fa pull-right mt-1"
                v-bind:class="[
                  childrenItem.active
                    ? 'fa fa-angle-down'
                    : 'fa fa-angle-right',
                ]"
                v-if="childrenItem.children"
              ></i>
            </a>

            <router-link
              class="lan-4"
              style="color: white"
              :class="{ active: childrenItem.active }"
              :to="childrenItem.path"
              v-if="childrenItem.type == 'link'"
              @click="setNavActive(childrenItem, index)"
              v-on:click="hidesecondmenu()"
            >
              {{ childrenItem.title }}
              <label
                :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
                v-if="childrenItem.badgeType"
                >{{ childrenItem.badgeValue }}</label
              >
              <i
                class="fa fa-angle-right pull-right mt-1"
                v-if="childrenItem.children"
              ></i>
            </router-link>

            <a
              :href="childrenItem.path"
              v-if="childrenItem.type == 'extLink'"
              class="submenu-title"
            >
              {{ childrenItem.title }}
              <label
                :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
                v-if="childrenItem.badgeType"
                >{{ childrenItem.badgeValue }}</label
              >
              <i
                class="fa fa-angle-right pull-right mt-1"
                v-if="childrenItem.children"
              ></i>
            </a>

            <a
              class="submenu-title"
              :href="childrenItem.path"
              target="_blank"
              v-if="childrenItem.type == 'extTabLink'"
            >
              {{ childrenItem.title }}
              <label
                :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
                v-if="childrenItem.badgeType"
                >{{ childrenItem.badgeValue }}</label
              >
              <i
                class="fa fa-angle-right pull-right mt-1"
                v-if="childrenItem.children"
              ></i>
            </a>

            <ul
              class="nav-sub-childmenu submenu-content"
              v-if="childrenItem.children"
              :class="{ opensubchild: childrenItem.active }"
            >
              <li
                v-for="(childrenSubItem, index) in childrenItem.children"
                :key="index"
              >
                <router-link
                  :class="{ active: childrenSubItem.active }"
                  :to="childrenSubItem.path"
                  v-if="childrenSubItem.type == 'link'"
                  v-on:click="hidesecondmenu()"
                  @click="setNavActive(childrenSubItem, index)"
                >
                  {{ childrenSubItem.title }}
                  <label
                    :class="
                      'badge badge-' + childrenSubItem.badgeType + ' pull-right'
                    "
                    v-if="childrenSubItem.badgeType"
                    >{{ childrenSubItem.badgeValue }}</label
                  >
                  <i
                    class="fa fa-angle-right pull-right"
                    v-if="childrenSubItem.children"
                  ></i>
                </router-link>

                <router-link
                  :to="childrenSubItem.path"
                  v-if="childrenSubItem.type == 'extLink'"
                >
                  {{ childrenSubItem.title }}
                  <label
                    :class="
                      'badge badge-' + childrenSubItem.badgeType + ' pull-right'
                    "
                    v-if="childrenSubItem.badgeType"
                    >{{ childrenSubItem.badgeValue }}</label
                  >
                  <i
                    class="fa fa-angle-right pull-right"
                    v-if="childrenSubItem.children"
                  ></i>
                </router-link>

                <router-link
                  :to="childrenSubItem.path"
                  v-if="childrenSubItem.type == 'extLink'"
                >
                  {{ childrenSubItem.title }}
                  <label
                    :class="
                      'badge badge-' + childrenSubItem.badgeType + ' pull-right'
                    "
                    v-if="childrenSubItem.badgeType"
                    >{{ childrenSubItem.badgeValue }}</label
                  >
                  <i
                    class="fa fa-angle-right pull-right"
                    v-if="childrenSubItem.children"
                  ></i>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li class="sidebar-list header-profile">
        <a class="sidebar-link sidebar-title">
          <ProfileMobile />
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import CryptoJS from "crypto-js";
import { mapState } from "vuex";
import { layoutClasses } from "../../constants/layout";
import ProfileMobile from "../header/profileMobile.vue";
import StorageConfig from "@/services/config/StorageConfig";
import { getIconUrl } from "@/utils/helper";

export default {
  name: "Navmenu",
  components: {
    ProfileMobile,
  },
  data() {
    return {
      isMobile: false,
      layoutobj: {},
      search: "",
      isTyping: false,
      isPath: "",
      secretKey: process.env.VUE_APP_SECRET_KEY,
    };
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.data,
      layout: (state) => state.layout.layout,
      sidebar: (state) => state.layout.sidebarType,
      activeoverlay: (state) => state.menu.activeoverlay,
      togglesidebar: (state) => state.menu.togglesidebar,
      width: (state) => state.menu.width,
      height: (state) => state.menu.height,
      margin: (state) => state.menu.margin,
      menuWidth: (state) => state.menu.menuWidth,
    }),
    filteredItems() {
      return this.menuItems;
    },
    layoutobject: {
      get: function () {
        return JSON.parse(
          JSON.stringify(
            layoutClasses.find(
              (item) => Object.keys(item).pop() === this.layout.settings.layout
            )
          )
        )[this.layout.settings.layout];
      },
      set: function () {
        this.layoutobj = layoutClasses.find(
          (item) => Object.keys(item).pop() === this.layout.settings.layout
        );
        this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[
          this.layout.settings.layout
        ];
        return this.layoutobj;
      },
    },
  },
  watch: {
    search() {
      if (this.search !== "") {
        this.isTyping = true;
      } else {
        this.isTyping = false;
      }
    },
    width() {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
      window.addEventListener("scroll", this.handleScroll);
      this.handleScroll();
      if (window.innerWidth < 992) {
        const newlayout = JSON.parse(
          JSON.stringify(this.layoutobject).replace(
            "horizontal-wrapper",
            "compact-wrapper"
          )
        );
        document.querySelector(".page-wrapper").className =
          "page-wrapper " + newlayout;
        this.$store.state.menu.margin = 0;
      } else {
        document.querySelector(".page-wrapper").className =
          "page-wrapper " + this.layoutobject;
      }

      if (
        (window.innerWidth < 1199 && this.layout.settings.layout === "Tokyo") ||
        (window.innerWidth < 1199 &&
          this.layout.settings.layout === "Moscow") ||
        (window.innerWidth < 1199 && this.layout.settings.layout === "Rome")
      ) {
        this.menuItems.filter((menuItem) => {
          menuItem.active = false;
        });
      }
    },
  },
  created() {
    this.getResolution();
    // this.getPath();
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    if (this.$store.state.menu.width < 991) {
      this.layout.settings.layout = "Dubai";
      this.margin = 0;
    }
    setTimeout(() => {
      const elmnt = document.getElementById("myDIV");
      this.$store.state.menu.menuWidth = elmnt.offsetWidth;
      this.$store.state.menu.menuWidth > window.innerWidth
        ? ((this.$store.state.menu.hideRightArrow = false),
          (this.$store.state.menu.hideLeftArrowRTL = false))
        : ((this.$store.state.menu.hideRightArrow = false),
          (this.$store.state.menu.hideLeftArrowRTL = true));
    }, 500);
    this.layoutobject = layoutClasses.find(
      (item) => Object.keys(item).pop() === this.layout.settings.layout
    );
    this.layoutobject = JSON.parse(JSON.stringify(this.layoutobject))[
      this.layout.settings.layout
    ];
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.$store.dispatch("menu/setData");
    this.menuItems.filter((items) => {
      if (items.path === this.$route.path)
        this.$store.dispatch("menu/setActiveRoute", items);
      if (!items.children) return false;
      items.children.filter((subItems) => {
        if (subItems.path === this.$route.path)
          this.$store.dispatch("menu/setActiveRoute", subItems);
        if (!subItems.children) return false;
        subItems.children.filter((subSubItems) => {
          if (subSubItems.path === this.$route.path)
            this.$store.dispatch("menu/setActiveRoute", subSubItems);
        });
      });
    });
  },
  methods: {
    getIconUrl,
    getResolution() {
      this.isMobile = window.screen.width < 760 ? true : false;
    },
    getPath() {
      const data = JSON.parse(StorageConfig.getData());
      const menu = data.menus;
      this.isPath = window.location.pathname;
      const jsonString = CryptoJS.AES.encrypt(
        StorageConfig.getData(),
        this.secretKey
      ).toString();
      const bytes = CryptoJS.AES.decrypt(jsonString, this.secretKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    },
    handleScroll() {
      if (window.scrollY > 400) {
        if (
          this.layoutobject.split(" ").pop() === "material-type" ||
          this.layoutobject.split(" ").pop() === "advance-layout"
        )
          document.querySelector(".sidebar-main").className =
            "sidebar-main hovered";
      } else {
        if (document.getElementById("sidebar-main"))
          document.querySelector(".sidebar-main").className = "sidebar-main";
      }
    },
    setNavActive(item) {
      this.$store.dispatch("menu/setNavActive", item);
      if (
        this.layoutobject.split(" ").includes("compact-sidebar") &&
        window.innerWidth > 991
      ) {
        if (this.menuItems.some((menuItem) => menuItem.active === true)) {
          this.$store.state.menu.activeoverlay = true;
        } else {
          this.$store.state.menu.activeoverlay = false;
        }
      }
    },
    hidesecondmenu() {
      if (window.innerWidth < 991) {
        (this.$store.state.menu.activeoverlay = false),
          (this.$store.state.menu.togglesidebar = false);
        this.menuItems.filter((menuItem) => {
          menuItem.active = false;
        });
      } else if (this.layoutobject.split(" ").includes("compact-sidebar")) {
        (this.$store.state.menu.activeoverlay = false),
          this.menuItems.filter((menuItem) => {
            menuItem.active = false;
          });
      }
    },
    handleResize() {
      this.$store.state.menu.width = window.innerWidth - 450;
    },
    navigateTo(routeName) {
      this.$router.push({ name: routeName });
    },
  },
};
</script>
<style scoped>
.input-with-icon {
  position: relative;
  margin: 20px;
}
.input-with-icon input::placeholder {
  padding-left: 30px; /* Adjust padding to accommodate icon */
}
.input-with-icon .fa {
  position: absolute;
  left: 10px; /* Adjust the position of the icon */
  top: 50%;
  transform: translateY(-50%);
}
.active {
  background-color: #8fceeb;
  color: rgb(59, 59, 59);
}
.active:hover {
  background-color: #8fceeb !important;
  color: rgb(59, 59, 59) !important;
}
.active-stroke {
  stroke: rgb(59, 59, 59) !important;
}
.active-text {
  color: rgb(59, 59, 59) !important;
}
@media only screen and (max-device-width: 720px) {
  .header-profile {
    display: block !important;
  }
}
@media screen and (min-width: 721px) and (max-width: 3000px) {
  .header-profile {
    display: none !important;
  }
}
</style>
